import React, {useMemo} from 'react';
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import {useSelector} from "react-redux";
import {FlexColumnSection, FlexRowSection} from "../../../styles/globalStyles";
import {
    getMembershipAddons,
    getMembershipPriceText,
    isLocationIL,
    sortCourseEventDays
} from "../../../helpers/functions";
import dayjs from "dayjs";
import {t} from "i18next";
import UserAvatar from "../../../components/UserAvatar";
import {DB_DATE_FORMAT} from "@arboxappv4/shared/src/constants/constants";

const CourseInfo = (props) => {
    const { course } = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)
    const box = useSelector(state => state.site.box)
    const {isMobile} = useScreenSize()

    const currencySymbol = useMemo(() => globalLocation?.currency_symbol, [globalLocation]);

    if(!course || !globalLocation) return <></>

    return (
        <FlexColumnSection gap={isMobile ? '10px' : '15px'} flex={'unset'}>
            <span>
                {getMembershipPriceText(course.membership_types[0], currencySymbol)}
                {(isLocationIL() && course.membership_types[0].max_installments > 1 && course.membership_types[0].price > 0) && <span> ({t('up-to-installments', {num: course.membership_types[0].max_installments})}) </span>}
                {course.membership_types[0].addons?.length > 0 && <div>{getMembershipAddons(course.membership_types[0].addons, currencySymbol)}</div>}
            </span>
            <FlexRowSection gap={'10px'}>
                <div>{dayjs(course.start_date, DB_DATE_FORMAT).format(globalLocation.date_format)} - {course.end_date ? dayjs(course.end_date, DB_DATE_FORMAT).format(globalLocation.date_format) : t('unlimited')}</div>
            </FlexRowSection>
            {course.coach && <UserAvatar user={course.coach} nameType={'full'}/>}
            {course.second_coach && <UserAvatar user={course.second_coach} nameType={'full'}/>}
            {box.locations_box.length > 1 && <span>{t('location')}: {course.locations_box.location}</span>}
        </FlexColumnSection>
    );
};

export default CourseInfo;